import React, { Component } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Button } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import { getWeekDetails, formatDisplayWeek } from '../../helper';
import Report from './Report';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';

/* Shop Summary report.

   Restores legacy Reports/RE_rpt_ShopSummary.aspx (SP_MS_FMS_RptShopSummery_Query), the
   per-shop week roll-up: the selected weeks plus the brought-forward position from every
   earlier week. Backed by services/report/shopSummary.php.

   Filters mirror the legacy page: a shop multi-select and a From / To week range. Only shops
   with at least one weekly sale inside the range appear, because the legacy proc INNER JOINed
   its sales subquery — a shop with payments but no sales was not listed. */

class ShopSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ShopList: [],
            Shop_Name: [],
            // Default to the current week so the dropdowns open on it; the report still waits
            // for "View", as every other report in the app does.
            From_Week: getWeekDetails().weekId,
            To_Week: getWeekDetails().weekId,
            showReport: false,
            ReportDetails: {},
            PC_GRP_ATT: localStorage.getItem('PC_GRP_ATT'),
            OTHER_DATA: localStorage.getItem('OTHER_DATA')
        }
    }

    componentDidMount() {
        this.getShopList()
    }

    // Same scoping rule as Profit & Loss and Shops Warehouse Delivery: a user pinned to an
    // account (PC_GRP_ATT) may only see that account's partner shops, never the full list.
    async getShopList() {
        let ShopList = []
        const { PC_GRP_ATT, OTHER_DATA } = this.state;

        if (PC_GRP_ATT && PC_GRP_ATT !== 'null') {
            if (OTHER_DATA) {
                try {
                    const parseData = JSON.parse(OTHER_DATA);
                    const partnerShops = parseData.ShopPartnerDetail ? JSON.parse(parseData.ShopPartnerDetail) : [];
                    for (let i = 0; i < partnerShops.length; i++) {
                        ShopList.push(partnerShops[i].ShopName)
                    }
                } catch (error) {
                    console.error('getShopList error :>> ', error);
                }
            }
        } else {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
                const shopData = res.data
                if (shopData.success === 1) {
                    for (let i = 0; i < shopData.data.length; i++) {
                        const shop = shopData.data[i];
                        ShopList.push({ value: shop.PC_SP_ID, label: shop.SP_NAME })
                    }
                }
            } catch (error) {
                console.error('getShopList error :>> ', error);
            }
        }

        this.setState({ ShopList })
    }

    handleChange(fieldName, evnt) {
        const targetValue = (fieldName === 'Shop_Name') ? evnt : evnt.target.value;
        // Any filter change invalidates what is on screen — drop it, so figures are never read
        // under the wrong week range or shop selection.
        this.setState({ [fieldName]: targetValue, showReport: false, ReportDetails: {} })
    }

    async viewReport() {
        const { From_Week, To_Week, Shop_Name } = this.state;

        if (From_Week === "" || To_Week === "") {
            Swal.fire('Error', 'Please select From / To week', 'error')
            return
        }
        if (From_Week > To_Week) {
            Swal.fire('Error', 'From Week must not be later than To Week', 'error')
            return
        }

        // A multi-select of shops becomes a plain integer CSV; the endpoint sanitizes each value
        // with intval() before it reaches IN(...). Empty means every shop.
        let shopIDs = ""
        for (let i = 0; i < (Shop_Name || []).length; i++) {
            shopIDs += `${Shop_Name[i].value},`
        }
        shopIDs = shopIDs.slice(0, -1)

        this.props.toggleLoader && this.props.toggleLoader(true)
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/shopSummary.php`, {
                Shop_IDs: shopIDs,
                From_Week,
                To_Week
            });
            if (res.data.success === 1) {
                this.setState({ ReportDetails: res.data.data, unapprovedWeeks: res.data.unapprovedWeeks || [], showReport: true })
            } else {
                this.setState({ showReport: false, ReportDetails: {} })
                Swal.fire('No Data', res.data.message || 'No record found!', 'info')
            }
        } catch (error) {
            console.error('shopSummary error :>> ', error);
            Swal.fire('Error', 'Could not load the report.', 'error')
        }
        this.props.toggleLoader && this.props.toggleLoader(false)
    }

    weekRangeLabel() {
        const from = formatDisplayWeek(this.state.From_Week);
        const to = formatDisplayWeek(this.state.To_Week);
        return from === to ? from : `${from}  |  ${to}`;
    }

    render() {
        return (
            <Container>
                <PageHeader breadcrumb="section" title="Shop Summary"
                    right={<PrintButton content={() => this.newRef} disabled={this.state.showReport !== true} />} />

                <FilterCard>
                    <Row style={{ alignItems: 'center' }} >
                        <Col md={5}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Shop <span style={{ fontSize: '11px', color: '#777' }} >(all if blank)</span></Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    isClearable={true}
                                    isMulti
                                    style={{ height: '32px' }}
                                    value={this.state.Shop_Name}
                                    options={this.state.ShopList}
                                    onChange={this.handleChange.bind(this, "Shop_Name")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label><span>From Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.From_Week}
                                    onChange={this.handleChange.bind(this, "From_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label><span>To Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.To_Week}
                                    onChange={this.handleChange.bind(this, "To_Week")}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
    
                    <Row>
                        <Col>
                            <Button className="add-button" onClick={this.viewReport.bind(this)} variant="contained" size='small' >View</Button>
                        </Col>
                    </Row>
                </FilterCard>

                {this.state.showReport === true ?
                    <Report
                        ref={el => (this.newRef = el)}
                        ReportDetails={this.state.ReportDetails}
                        WeekRange={this.weekRangeLabel()}
                        UnapprovedWeeks={this.state.unapprovedWeeks}
                    />
                    :
                    ""
                }
            </Container >
        );
    }
}

export default ShopSummary;
